import { render, staticRenderFns } from "./OnboardingPersonal.vue?vue&type=template&id=d1406f96&scoped=true"
import script from "./OnboardingPersonal.vue?vue&type=script&lang=js"
export * from "./OnboardingPersonal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1406f96",
  null
  
)

export default component.exports